import { useEffect, useMemo } from "react";

interface UseSecondServiceStateParams {
    isSecondServiceForm: boolean | undefined;
    formSubmitted: boolean;
    setSecondServiceSubmitted: (value: boolean) => void;
    tags: { [x: string]: { slug: string; active: boolean } } | undefined;
}

interface UseSecondServiceStateResult {
    isSecondServiceSelected: boolean;
}

export function useSecondServiceState({
    isSecondServiceForm,
    formSubmitted,
    setSecondServiceSubmitted,
    tags,
}: UseSecondServiceStateParams): UseSecondServiceStateResult {
    useEffect(() => {
        if (isSecondServiceForm && formSubmitted) {
            setSecondServiceSubmitted(true);
        }
    }, [formSubmitted]);

    const isSecondServiceSelected = useMemo(() => {
        if (tags) {
            const tagsKeys = Object.keys(tags);
            let tagsSelected = false;
            tagsKeys.forEach((tag) => {
                tagsSelected = tagsSelected || tags[tag].active;
            });
            return tagsSelected;
        }
        return false;
    }, [tags]);

    return { isSecondServiceSelected };
}
